import React, { useRef, useState } from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import {
  Button, Row, Spinner, Table,
} from 'reactstrap';
import { GET_MSG } from '../../../query/query';
import { Modal } from '../components/Modal';
import { DELETE_MESSAGE } from '../../../mutation/mutation';

const Message = ({
  idMessage,
  date: dateProp,
  senderUser: { firstname: firstName, email },
  status,
  onCrossClicked,
}) => {
  const { current: date } = useRef((new Date(+dateProp)).toLocaleString());

  return (
    <tr>
      <td>{firstName}</td>
      <td>{email}</td>
      <td>{status}</td>
      <td>{date}</td>
      <td>
        <Button
          size="sm"
          type="submit"
          color="danger"
          onClick={() => onCrossClicked(idMessage)}
        >
          X
        </Button>
      </td>

    </tr>
  );
};

const MessagesDisplay = ({
  error, loading, messages, onCrossClicked,
}) => {
  if (error || (loading && !messages.length)) {
    return (
      <tr>
        <td colSpan="5">
          {error ? 'error' : 'loading...'}
        </td>
      </tr>
    );
  }
  return messages
    .sort(({ date: date1 }, { date: date2 }) => date2 - date1)
    .map((message) => (
      <Message
        key={message._id}
        idMessage={message._id}
        type={message.type}
        date={message.date}
        status={message.status.label}
        senderUser={message.senderUser}
        onCrossClicked={onCrossClicked}
      />
    ));
};

const MessagesList = ({ boxId }) => {
  const [allMessagesFetched, setAllMessagesFetched] = useState(false);
  const [isModalDelete, setIsModalDelete] = useState(false);
  const [idMessageClicked, setIdMessageClicked] = useState(null);
  const [skip, setSkip] = useState(0);
  const {
    data: { savGetMessagesByBox: messages = [] } = {},
    error,
    fetchMore,
    loading: messagesLoading,
  } = useQuery(GET_MSG, { variables: { boxId, skip } });

  const [deleteMessage, { loading: deleteLoading }] = useMutation(DELETE_MESSAGE, {
    update: (cache, { data: { savDeleteMessage } }) => {
      let { savGetMessagesByBox } = cache.readQuery({
        query: GET_MSG,
        variables: { boxId },
      });
      savGetMessagesByBox = savGetMessagesByBox
        .filter(({ _id }) => _id !== savDeleteMessage);
      cache.writeQuery({
        query: GET_MSG,
        variables: { boxId },
        data: { savGetMessagesByBox },
      });
    },
  });

  const fetchMoreMessages = async () => {
    const newSkip = skip + 10;
    await fetchMore({
      updateQuery: (prev, { fetchMoreResult }) => {
        if (fetchMoreResult
          && fetchMoreResult.savGetMessagesByBox
          && fetchMoreResult.savGetMessagesByBox.length < 10) {
          setAllMessagesFetched(true);
        }
        if (!fetchMoreResult || !(fetchMoreResult.savGetMessagesByBox || []).length) {
          return prev;
        }
        return {
          savGetMessagesByBox: [
            ...prev.savGetMessagesByBox,
            ...fetchMoreResult.savGetMessagesByBox,
          ],
        };
      },
      variables: { boxId, skip: newSkip },
    });
    setSkip(newSkip);
  };

  const onCrossClicked = (idMessage) => {
    setIdMessageClicked(idMessage);
    setIsModalDelete(true);
  };

  const onClickReject = () => {
    setIsModalDelete(false);
  };

  const onClickAccept = async () => {
    await deleteMessage({ variables: { messageId: idMessageClicked } });
    setIsModalDelete(false);
  };

  return (
    <Row>
      <Table hover>
        <thead>
          <tr>
            <th>First Name</th>
            <th>Email</th>
            <th>Status</th>
            <th>Date</th>
            <th>x</th>
          </tr>
        </thead>
        <tbody>
          <MessagesDisplay
            boxId={boxId}
            error={error}
            loading={messagesLoading}
            messages={messages}
            onCrossClicked={(idMessage) => onCrossClicked(idMessage)}
          />
        </tbody>
      </Table>
      {(messages.length && !allMessagesFetched) && (
        messagesLoading
          ? <Spinner color="secondary" style={{ position: 'relative', top: -14, left: 14 }} />
          : (
            <Button
              type="button"
              color="primary"
              onClick={fetchMoreMessages}
            >
              Fetch more
            </Button>
          )
      )}
      {(isModalDelete) && (
        <Modal
          text="Are you sure to delete this message ?"
          loading={deleteLoading}
          onClickReject={onClickReject}
          onClickAccept={onClickAccept}
        />
      )}
    </Row>
  );
};

export default MessagesList;



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/table/messages-list.js